import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import { baseQueryWithInterceptor } from '../utils/baseQueryWithInterceptor';
import { IBadgeResponse } from '../../interfaces/badge.interface';

const badgeApi = createApi({
  reducerPath: 'badgeApi',
  baseQuery: baseQueryWithInterceptor(`${config.API_BASE_URL}/badge`),
  tagTypes: ['badge'],

  endpoints: builder => ({
    getBadgesByUserId: builder.query<IBadgeResponse[], string>({
      query: (userId: string) => `/${userId}`,
      providesTags: ['badge'],
    }),
  }),
});

export const { useGetBadgesByUserIdQuery } = badgeApi;

export default badgeApi;
